import store from "@/store";
import { GroupState } from "@/types/group";
import { computed, onMounted, onUnmounted } from "vue";
const useActiveGroups = () => {
    onMounted(async () => await store.dispatch.groups.subscribe(GroupState.Active));
    onUnmounted(async () => await store.dispatch.groups.unsubscribe(GroupState.Active));
    return {
        activeGroups: computed(() => store.state.groups.active),
        activeGroupsDataReceived: computed(() => store.state.groups.dataReceived.active)
    };
};
const useWaitingGroups = () => {
    onMounted(async () => await store.dispatch.groups.subscribe(GroupState.Waiting));
    onUnmounted(async () => await store.dispatch.groups.unsubscribe(GroupState.Waiting));
    return {
        waitingGroups: computed(() => store.state.groups.waiting),
        waitingGroupsDataReceived: computed(() => store.state.groups.dataReceived.waiting)
    };
};
const useFinishedGroups = () => {
    onMounted(async () => await store.dispatch.groups.subscribe(GroupState.Finished));
    onUnmounted(async () => await store.dispatch.groups.unsubscribe(GroupState.Finished));
    return {
        finishedGroups: computed(() => store.state.groups.finished),
        finishedGroupsDatReceived: computed(() => store.state.groups.dataReceived.finished)
    };
};
const useArchivedGroups = () => {
    onMounted(async () => await store.dispatch.groups.subscribe(GroupState.Archived));
    onUnmounted(async () => await store.dispatch.groups.unsubscribe(GroupState.Archived));
    return {
        archivedGroups: computed(() => store.state.groups.archived),
        archivedGroupsDataReceived: computed(() => store.state.groups.dataReceived.archived)
    };
};
const useGroups = () => {
    return {
        createGroup: async (newGroup) => await store.dispatch.groups.create(newGroup),
        updateGroup: async (groupId, group) => await store.dispatch.groups.update({ groupId, group }),
        deleteGroup: async (groupId) => await store.dispatch.groups.delete(groupId)
    };
};
const useAllGroups = () => {
    return {
        ...useActiveGroups(),
        ...useWaitingGroups(),
        ...useFinishedGroups()
    };
};
export { useGroups, useAllGroups, useActiveGroups, useWaitingGroups, useArchivedGroups, useFinishedGroups };
